// Geleneksel uygulama seansı — biçim yardımcıları (tab, klinik listesi, drawer ortak).

export const SESSION_STATUS = {
  pending_consent: { label: "Onay bekliyor", tone: "warning" },
  completed: { label: "Tamamlandı", tone: "success" },
  cancelled: { label: "İptal edildi", tone: "neutral" },
};

/** Onay isteğinin ne zamandır beklediği: "az önce", "12 dk önce", "3 saat önce", "dün", "4 gün önce". */
export const formatSentAgo = (value) => {
  const d = value ? new Date(value) : null;
  if (!d || Number.isNaN(d.getTime())) return "";
  const min = Math.max(0, Math.floor((Date.now() - d.getTime()) / 60000));
  if (min < 1) return "az önce";
  if (min < 60) return `${min} dk önce`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours} saat önce`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "dün";
  if (days < 30) return `${days} gün önce`;
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
};

export const CONSENT_METHOD_LABEL = { paper: "Kağıt", mobile: "Mobil onay" };

const pad = (n) => String(n).padStart(2, "0");

/** Date → { date: "YYYY-MM-DD", time: "HH:mm" } (yerel saat). */
export const splitDateTime = (value) => {
  const d = value ? new Date(value) : new Date();
  if (Number.isNaN(d.getTime())) return { date: "", time: "" };
  return {
    date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
    time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
  };
};

/** "YYYY-MM-DD" + "HH:mm" → ISO (yerel saatle). */
export const joinDateTime = (date, time) => {
  if (!date) return null;
  const [y, m, d] = date.split("-").map(Number);
  const [hh, mm] = String(time || "00:00").split(":").map(Number);
  const dt = new Date(y, (m || 1) - 1, d || 1, hh || 0, mm || 0);
  return Number.isNaN(dt.getTime()) ? null : dt.toISOString();
};

export const formatDateTimeTr = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("tr-TR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const formatDateTr = (value) => {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" });
};

export const personName = (u) => {
  if (!u) return "";
  const title = u.title ? `${u.title} ` : "";
  return `${title}${u.name || ""} ${u.surname || ""}`.trim();
};

export const EMPTY_RECOMMENDATION = { name: "", usage: "", duration: "", note: "" };

/** Seans kaydı → editör formu. */
export const sessionToForm = (s) => {
  const { date, time } = splitDateTime(s?.performedAt);
  return {
    practiceId: s?.practice?._id || s?.practice || "",
    date,
    time,
    durationMin: s?.durationMin != null ? String(s.durationMin) : "",
    regions: Array.isArray(s?.regions) ? s.regions.map((r) => ({ ...r })) : [],
    materials: s?.materials || "",
    observation: s?.observation || "",
    patientFeedback: s?.patientFeedback || "",
    recommendations: Array.isArray(s?.recommendations) ? s.recommendations.map((r) => ({ ...r })) : [],
    status: s?.status || "completed",
  };
};

/** Editör formu → API gövdesi. */
export const formToPayload = (form) => ({
  practiceId: form.practiceId,
  performedAt: joinDateTime(form.date, form.time) || undefined,
  durationMin: form.durationMin === "" ? null : Number(form.durationMin),
  regions: (form.regions || []).map((r) => ({ view: r.view, x: r.x, y: r.y, label: String(r.label || "").trim() })),
  materials: form.materials,
  observation: form.observation,
  patientFeedback: form.patientFeedback,
  recommendations: (form.recommendations || [])
    .map((r) => ({
      name: String(r.name || "").trim(),
      usage: String(r.usage || "").trim(),
      duration: String(r.duration || "").trim(),
      note: String(r.note || "").trim(),
    }))
    .filter((r) => r.name),
});
